// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-button{position:relative;display:inline-block;border-radius:3px;margin-bottom:15px;padding:10px 15px;font-size:16px;cursor:pointer;clear:both}.input-button.input-button--no-margin{margin-bottom:0}.input-button.input-button--small{font-size:12px;padding:8px 12px}", ""]);
// Exports
module.exports = exports;
